import { useQuery } from "@tanstack/react-query";
import { getOrganizations } from "../../services/organization";

const useGetOrganizations = (applicantId: number) => {
    return useQuery({
        queryFn: () => getOrganizations(applicantId),
        queryKey: ["organizations", applicantId],
        retry: 0,
        refetchOnWindowFocus: false,
    });
};
export default useGetOrganizations;